module.exports = __webpack_public_path__ + "img/how-to-use-gbwhatsapp-without-banned.4522ba5b.webp";